import React, { useEffect, useRef, useState } from 'react';
import Header from './Header';
import Intro from './Intro';
import IntroCrafting from './IntroCrafting';
import SkillsTicker from './SkillsTicker';
import Statistics from './Statistics';
import Experience from './Experience';
import Portfolio from './Portfolio';
import ClientThoughts from './ClientThoughts';
import Contact from './Contact';
import Footer from './Footer';

const Home = () => {
  const [isHeaderHidden, setIsHeaderHidden] = useState(false);
  const lastScrollYRef = useRef(0);
  const isMobileActiveRef = useRef(false);
  const rafIdRef = useRef(null);

  // Determine if mobile behavior should be active
  const computeIsMobile = () => window.matchMedia('(max-width: 768px)').matches;

  useEffect(() => {
    const onResize = () => {
      // The scroll behavior is now active on all devices
      // No need to force header visibility on desktop
    };

    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const SCROLL_DELTA_THRESHOLD = 4; // pixels to avoid jitter
    const MIN_HIDE_SCROLL_Y = 50; // don't hide until user scrolls a bit

    const handleScroll = () => {
      // Use rAF to batch DOM reads/writes smoothly
      if (rafIdRef.current) return;
      rafIdRef.current = window.requestAnimationFrame(() => {
        rafIdRef.current = null;
        const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
        const lastY = lastScrollYRef.current;
        const delta = currentY - lastY;

        // Always show near top
        if (currentY <= 10) {
          if (isHeaderHidden) setIsHeaderHidden(false);
          lastScrollYRef.current = currentY;
          return;
        }

        if (delta > SCROLL_DELTA_THRESHOLD && currentY > MIN_HIDE_SCROLL_Y) {
          // Scrolling down
          if (!isHeaderHidden) setIsHeaderHidden(true);
        } else if (delta < -SCROLL_DELTA_THRESHOLD) {
          // Scrolling up
          if (isHeaderHidden) setIsHeaderHidden(false);
        }

        lastScrollYRef.current = currentY;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafIdRef.current) {
        window.cancelAnimationFrame(rafIdRef.current);
        rafIdRef.current = null;
      }
    };
  }, [isHeaderHidden]);

  return (
    <div>
      <Header isHidden={isHeaderHidden} />
      <Intro />
      <IntroCrafting />
      <SkillsTicker />
      <Statistics />
      <Experience />
      <SkillsTicker />
      <Portfolio />
      <ClientThoughts />
      <Contact />
      <Footer show={false} />
    </div>
  );
};

export default Home;
